import tokens from '../tokens/color-tokens.json';
import wcag from '../tokens/color-wcag.json';

export const brandColors = {
  ...tokens.primary,
  ...tokens.secondary,
  ...tokens.states,
  ...tokens.greyscale
};

export const colorOptions = Object.keys(brandColors);

/**
 * Whether a colour passes WCAG contrast for text, per the Figma palette.
 * Undefined for colours that are not in the Figma palette.
 */
export const wcagCompliant: Record<string, boolean | undefined> = wcag;

/**
 * Palette key in, colour out.
 *
 * An unknown key falls back to `fallback` instead of being passed through.
 * Builder content saved before the palette rename still carries keys such as
 * "action-blue"; passing one straight to a style attribute is invalid CSS, so
 * the declaration is dropped and the element renders uncoloured.
 */
export const resolveColorToken = (
  value: string | undefined,
  fallback: string
): string => brandColors[value as keyof typeof brandColors] ?? fallback;
